<div bsModal #modal="bs-modal" class="modal fade nps-form" role="dialog" aria-hidden="false">
    <div class="modal-dialog me-nps-modal" tabindex="1" [attr.aria-label]="'NPS modal' | translate">
        <div class="modal-content" *ngIf="data">
            <span tabindex="1" [attr.aria-label]="'Close nps modal' | translate" class="btn fas fa-times close-btn" (click)="closeModal()"></span>
            <div *ngIf="!commentSection">
                <div tabindex="1" class="me-nps-modal--title">
                    {{data.scoreTitle}}
                </div>
                <div class="me-nps-modal--rating">
                    <div class="me-nps-modal--rating--block">
                        <div tabindex="1" class="me-nps-modal--rating--block--inner" *ngFor="let _ of [].constructor(10); let i = index" 
                            (click)="score = i + 1;" (keyup.enter)="score = i + 1;" [class.active]="i + 1 === score">
                            {{i + 1}}
                        </div>
                    </div>
                    <div class="me-nps-modal--rating--label">
                        <span>{{data.minimumScoreLabel}}</span>
                        <span>{{data.maximumScoreLabel}}</span>
                    </div>
                </div>
                <div class="me-nps-modal--button">
                    <button [attr.tabindex]="score === 0 ? -1 : 1" class="btn btn--primary" [class.disabled]="score === 0" (click)="next()">
                        {{ 'Send' | translate }}
                    </button>
                </div>
            </div>
            <div *ngIf="commentSection">
                <div tabindex="1" class="me-nps-modal--title">
                    <ng-container *ngIf="score < 9">
                        {{data.badScoreCommentTitle}}
                    </ng-container>
                    <ng-container *ngIf="score >= 9">
                        {{data.goodScoreCommentTitle}}
                    </ng-container>
                </div>
                <textarea tabindex="1" class="me-nps-modal--comment" [(ngModel)]="comment" placeholder="{{data.commentPlaceHolder}}">
                </textarea>
                <div class="me-nps-modal--button">
                    <button [attr.tabindex]="comment === '' ? -1 : 1" class="btn btn--primary" [class.disabled]="comment === ''" (click)="submit()">
                        {{ 'Send' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>